import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classname from 'classname';

export default class Icon extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    isBordered: PropTypes.bool,
    className: PropTypes.string,
    size: PropTypes.number,
    onClick: PropTypes.func,
    style: PropTypes.object,
  };

  render() {
    const { name, size, className, isBordered, onClick, color, style } = this.props;
    return (
      <span
        className={classname(`icon`, className)}
        style={{ border: isBordered ? '1px solid' : 'none', ...(style || {}) }}
        onClick={onClick}
      >
        <i className="material-icons" style={{ fontSize: size, color: color }}>
          {name}
        </i>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Icon.js